/**To view a specific event related detials and location on maps */

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  getAllEventType,
  getAllRolesByUsers,
  getincidents,
  getTaskConfigsURL,
  getThemeURL,
  getUsersFromAppByRole,
} from "../../../../Services/EndPoints";
import { getData, postDataWithBody } from "../../../../Services/Services";
import { toast } from "react-toastify";
import MapWrapperForIncident from "../../../../Components/UiComponents/MapWrapper/MapWrapperForIncidents";

const EventDetails = () => {
  const location = useLocation();

  // Image gallery state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [mediaList, setMediaList] = useState([]);
  const [IncidentCategories, setIncidentCategories] = useState([]);
  const [role, setRole] = useState([]);
  const [SubCat, setSubCat] = useState([]);
  const [Incidentsdata, setIncidentsdata] = useState([]);
  const [UserList, setUserList] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: Incidentsdata?.latitude || 25.4223,
    lng: Incidentsdata?.longitude || 86.1391,
  });
  const [showPreview, setShowPreview] = useState(false);
  // const [userProfile, setUserProfile] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  // Try to get data from location.state or fallback to sessionStorage
  const initialEventData =
    location.state?.eventData ||
    JSON.parse(sessionStorage.getItem("eventData"));
  const eventData = initialEventData;

  // Save to sessionStorage if it's coming from location.state
  useEffect(() => {
    if (location.state?.eventData) {
      sessionStorage.setItem(
        "eventData",
        JSON.stringify(location.state.eventData)
      );
    }
  }, [location.state?.eventData]);

  useEffect(() => {
    fetchIncidentDetails();
    fetchrole();
    fetchEventType();
    fetchIncidents();
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Incidentsdata?.latitude && Incidentsdata?.longitude) {
      setMapCenter({
        lat: Incidentsdata.latitude,
        lng: Incidentsdata.longitude,
      });
    }
  }, [Incidentsdata]);



  const fetchEventType = async () => {
    try {
      const response = await getData(
        getAllEventType + eventData?.incidentCategoryId
      );
      if (response && Array.isArray(response) && response.length > 0) {
        setSubCat(response); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  console.log(SubCat, "subcatactatcat");

  const fetchrole = async () => {
    try {
      const response = await getData(
        getAllRolesByUsers + eventData?.assignedTeam
      );
      if (response && Array.isArray(response) && response.length > 0) {
        setRole(response); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchIncidentDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["INCDNT_CAT"],
        {}
      );

      if (response && Array.isArray(response)) {
        // Store the incident categories in state
        setIncidentCategories(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  // Initialize media list from event data
  useEffect(() => {
    if (eventData?.mediaList && eventData.mediaList.length > 0) {
      setMediaList(eventData.mediaList);
    }
    // Remove the else block that sets placeholder images
  }, [eventData]);

  // const nextImage = () => {
  //   setCurrentImageIndex((prevIndex) =>
  //     prevIndex === mediaList.length - 1 ? 0 : prevIndex + 1
  //   );
  // };

  // const prevImage = () => {
  //   setCurrentImageIndex((prevIndex) =>
  //     prevIndex === 0 ? mediaList.length - 1 : prevIndex - 1
  //   );
  // };

  // Check if current media item is a video (based on path extension)
  const isCurrentItemVideo = () => {
    if (!mediaList[currentImageIndex]) return false;
    const path = mediaList[currentImageIndex].mediaPath.toLowerCase();
    return (
      path.endsWith(".mp4") || path.endsWith(".mov") || path.endsWith(".avi")
    );
  };

  // Extract date and time from dateTime string
  // const [date, time] = eventData?.incidentDateAndTime
  //   ? eventData.incidentDateAndTime.split(" ")
  //   : ["N/A", "N/A"];

  // Function to display data or N/A if not available
  const displayData = (data) => data || "N/A";

  // Get the criticality color based on severity level
  // const getCriticalityColor = (severity) => {
  //   let textColor;
  //   switch (severity?.toUpperCase()) {
  //     case "CRITICAL":
  //       textColor = "#FF5D30";
  //       break;
  //     case "HIGH":
  //       textColor = "#FF5D30";
  //       break;
  //     case "MEDIUM":
  //       textColor = "#FFA100";
  //       break;
  //     case "LOW":
  //       textColor = "#40BAC2";
  //       break;
  //     default:
  //       textColor = "#808080";
  //   }
  //   return textColor;
  // };

  // Get styling for the current event
  //const criticalityColor = getCriticalityColor(eventData?.severityLevel);

  // Map configuration for MapWrapper
  const mapTitle = "Incident Location";

  console.log(eventData.incidentId, "idididid");

  const fetchIncidents = async () => {
    try {
      const response = await getData(getincidents + eventData?.incidentId);
      if (response) {
        setIncidentsdata(response); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  console.log(Incidentsdata, "IncidentsdataIncidentsdataIncidentsdataIncidentsdata")
const datatosubcat = (id) => {
    const match = SubCat.find((item) => item.id === id);
    return match ? match.value : "Unknown";
  };


  const mapCoordinates = [
  {
    x: mapCenter.lat,
    y: mapCenter.lng,
    locationId: 1,
    popupdata: {
      title: Incidentsdata?.incidentName,
      description: Incidentsdata?.address,
      status: Incidentsdata?.status,
      eventname: eventData?.eventName,
      eventtype: datatosubcat(eventData?.eventSubCategoryId),
      incidentcategory: displayData(
        IncidentCategories.find(
          (cat) => cat.id === eventData?.incidentCategoryId
        )?.value
      ),
      severity: displayData(eventData?.severityLevel),
      eventdescription: displayData(eventData?.description),
      type: "Event",
      // Add media data to popup
      mediaList: (() => {
        const userClosedMedia = mediaList.filter(
          (media) => media.type === "EVENT_USER_CLOSED_UPDATE"
        );
        const fallbackCreateMedia = mediaList.filter(
          (media) => media.type === "EVENT_CREATE"
        );
        return userClosedMedia.length > 0 ? userClosedMedia : fallbackCreateMedia;
      })(),
    },
  },
];



  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    // Format the date part as dd-mm-yy
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).toString().slice(-2);

    // Format the time part as HH:mm AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12
    const formattedHours = String(hours).padStart(2, "0");

    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

    return `${dd}-${mm}-${yy} ${formattedTime}`;
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      // setUserProfile(userProfile);
      if (userProfile && userProfile.length > 0) {
        getUserList(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
   if (profile.role_name === "SUPER ADMIN") {
      return {
        admin_role: "SA",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    } else if (profile.is_admin === true) {
      return {
        admin_role: "HO",
        bank_id: profile.bank_id || null,
        userId: profile.id,
      };
    }
    else {
      return {
        admin_role: "U",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    }
  };

  const getUserList = async (profile) => {
    // setLoader(true);
    try {
      const payload = createPayload(profile);
      const fetchedUsers = await postDataWithBody(getUsersFromAppByRole, payload, {});
      const sortedUsers = fetchedUsers.sort((a, b) =>
        a.first_name > b.first_name ? 1 : -1
      );
      const userList = sortedUsers.map((user) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
        created_by: user.created_by, // Make sure this field is captured
      }));
      setUserList(userList);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    } finally {
      // setLoader(false);
    }
  };

  console.log(UserList, "userlistlistlist");

  
  // Handler for recording chosen coordinates if needed
  const handleChooseCoordinates = () => {
    console.log(
      `Selected coordinates: ${Incidentsdata.longitude}, ${Incidentsdata.latitude}`
    );
  };

  // Device types for map dropdown if needed
  // const deviceTypes = [
  //   { id: "CC Camera", value: "CC Camera" },
  //   { id: "Smoke Detector", value: "Smoke Detector" },
  //   { id: "Motion Sensor", value: "Motion Sensor" },
  //   { id: "Access Control", value: "Access Control" },
  // ];
  const handleImageClick = () => {
    setZoomLevel((prevZoom) => (prevZoom === 1 ? 2 : 1)); // Toggle between 100% and 200% zoom
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartPos({ x: e.clientX, y: e.clientY });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - startPos.x;
    const dy = e.clientY - startPos.y;

    setPosition((prevPos) => ({
      x: prevPos.x + dx,
      y: prevPos.y + dy,
    }));

    setStartPos({ x: e.clientX, y: e.clientY });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };


  return (
    <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
      <div className="row g-0" style={{ height: "160vh", overflow: "hidden" }}>
        {/* Left Panel - Event Details with scrollbar */}
        <div className="col-md-6 p-4 bg-white" style={{ height: "100vh" }}>
          {/* Grid Layout for Event Details - 3 columns with reduced spacing */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {/* First row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Event ID
              </p>
              <p className="mb-0">{displayData(eventData?.eventId)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Event Name
              </p>
              <p className="mb-0">{displayData(eventData?.eventName)}</p>
            </div>

            {/* Second row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Severity
              </p>
              <div className="mb-0">
                {displayData(eventData?.severityLevel)}
              </div>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Source System
              </p>
              <p className="mb-0">{displayData(eventData?.sourceSystem)}</p>
            </div>

            {/* Third row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Assigned To User
              </p>
              <p className="mb-0">
                {displayData(eventData?.assignedToUserName)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Assigned Team
              </p>
              <p className="mb-0">{role[0]?.role_name}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                SLA Target
              </p>
              <p className="mb-0">{displayData(eventData?.slaTarget)}</p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Event Type
              </p>
              <p className="mb-0">
                {datatosubcat(eventData?.eventSubCategoryId)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident Category
              </p>
              <p className="mb-0">
                {displayData(
                  IncidentCategories.find(
                    (cat) => cat.id === eventData?.incidentCategoryId
                  )?.value
                )}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Created by
              </p>
              <p className="mb-0">
                {displayData(
                  UserList.find((cat) => cat.value === eventData?.created_by)
                    ?.label
                )}
              </p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Created on
              </p>
              <p className="mb-0">{formatDateTime(eventData?.created_on)}</p>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Event Description
              </p>
              <p className="mb-0">{displayData(eventData?.description)}</p>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Resolution Start Date & Time
              </p>
              <p className="mb-0">
                {formatDateTime(
                  eventData?.eventIncidentMapEntity?.workStartDateAndTime
                )}
              </p>
            </div>
            <div className="col-6">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Resolution End Date & Time
              </p>
              <p className="mb-0">
                {formatDateTime(
                  eventData?.eventIncidentMapEntity?.resoultionEndDateAndTime
                )}
              </p>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Root Cause
              </p>
              <p className="mb-0">
                {displayData(eventData?.eventIncidentMapEntity?.rootCause)}
              </p>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Action Taken(In Progress)
              </p>
              <p className="mb-0">
                {displayData(
                  eventData?.eventIncidentMapEntity?.actionTakenInProgress
                )}
              </p>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Action Taken(Closed)
              </p>
              <p className="mb-0">
                {displayData(
                  eventData?.eventIncidentMapEntity?.actionTakenCompleted
                )}
              </p>
            </div>
          </div>

          {/* Images & Videos Section */}
          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-2"
                style={{ color: "#1a7a73", fontSize: "15px" }}
              >
                Images:
              </p>
              {(() => {
                // Define finalMediaList at the component level
                const userClosedMedia = mediaList.filter(
                  (media) => media.type === "EVENT_USER_CLOSED_UPDATE"
                );
                const fallbackCreateMedia = mediaList.filter(
                  (media) => media.type === "EVENT_CREATE"
                );

                // Decide which list to use
                const finalMediaList = userClosedMedia.length > 0 ? userClosedMedia : fallbackCreateMedia;

                if (finalMediaList.length > 0) {
                  return (
                    <div>
                      <div
                        className="d-flex position-relative"
                        style={{
                          marginBottom: "20px",
                          gap: "10px",
                          overflowX: "hidden",
                        }}
                      >
                        {finalMediaList.map((media, index) => {
                          console.log(finalMediaList, "index");
                          const isVideo =
                            media.mediaPath.toLowerCase().endsWith(".mp4") ||
                            media.mediaPath.toLowerCase().endsWith(".mov") ||
                            media.mediaPath.toLowerCase().endsWith(".avi");

                          const filePath = media.fileName || media.mediaPath || "";
                          const fileName = filePath.split("/").pop();
                          const dotIndex = fileName.lastIndexOf(".");
                          const nameWithoutExtension =
                            dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;

                          return (
                            <div
                              key={index}
                              className="position-relative"
                              style={{
                                width: "158px",
                                height: "190px",
                                flexShrink: 0,
                                borderRadius: "8px",
                                overflow: "hidden",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                setCurrentImageIndex(index);
                                setShowPreview(true);
                              }}
                            >
                              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                              <img
                                src={media.mediaPath}
                                alt={`Event image ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "160px",
                                  objectFit: "cover",
                                  opacity: index === currentImageIndex ? 1 : 0.7,
                                }}
                              />

                              {isVideo && (
                                <div className="position-absolute top-50 start-50 translate-middle">
                                  <div
                                    style={{
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                      borderRadius: "50%",
                                      width: "30px",
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginLeft: "-60px",
                                    }}
                                  >
                                    <i className="bi bi-play-fill text-white"></i>
                                  </div>
                                </div>
                              )}

                              <div
                                style={{
                                  fontSize: "12px",
                                  marginTop: "5px",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: "100%",
                                }}
                                title={nameWithoutExtension}
                              >
                                {nameWithoutExtension}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                } else {
                  return <p className="text-muted">No images available</p>;
                }
              })()}
            </div>
          </div>
        </div>

        {/* Right Panel - Map with MapWrapper component */}
        <div className="col-md-6 p-0" style={{ overflow: "hidden" }}>
          <MapWrapperForIncident
            title={mapTitle}
            containerStyles={{
              height: "105vh",
              display: "flex",
              flexDirection: "column",
            }}
            headerStyles={{
              backgroundColor: "#1a7a73",
              color: "white",
              padding: "8px 16px",
            }}
            bodyStyles={{
              flex: 1,
              overflow: "hidden",
            }}
            coordinates={mapCoordinates}
            chooseCoordinates={handleChooseCoordinates}
            zoom={15} // Increased zoom level for closer view
            popUpShow={true}
            center={mapCenter} // Add this prop to center the map
            key={`${mapCenter.lat}-${mapCenter.lng}`} // Force re-render when center changes
          />
        </div>
      </div>
      {showPreview && (() => {
        // Calculate finalMediaList again for the preview section
        const userClosedMedia = mediaList.filter(
          (media) => media.type === "EVENT_USER_CLOSED_UPDATE"
        );
        const fallbackCreateMedia = mediaList.filter(
          (media) => media.type === "EVENT_CREATE"
        );
        const finalMediaList = userClosedMedia.length > 0 ? userClosedMedia : fallbackCreateMedia;

        return (
          <div
            role="dialog"
            aria-modal="true"
            onClick={() => setShowPreview(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // Changed to center for full screen experience
              zIndex: 9999,
            }}
          >
            <div
              style={{
                position: "relative",
                width: "95vw", // Almost full width
                height: "90vh", // Almost full height
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Circle close button */}
              <button
                onClick={() => setShowPreview(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "22px",
                  lineHeight: "36px",
                  textAlign: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  zIndex: 10000, // Ensure it's above everything else
                }}
                aria-label="Close"
              >
                &times;
              </button>

              {/* Media container */}
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  overflow: "auto", // Changed to auto to allow scrolling if needed
                  width: "100%",
                  height: "100%", // Take full height of parent
                  boxSizing: "border-box",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: zoomLevel > 1 ? "grab" : "auto",
                  userSelect: "none",
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
              >
                {isCurrentItemVideo() ? (
                  <video
                    controls
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%", // Ensure video fits in container
                      borderRadius: "8px",
                    }}
                  >
                    <source src={finalMediaList[currentImageIndex]?.mediaPath} />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={finalMediaList[currentImageIndex]?.mediaPath}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%", // Ensure image fits in container
                      objectFit: "contain",
                      transform: `scale(${zoomLevel}) translate(${position.x}px, ${position.y}px)`,
                      transition: "transform 0.3s ease-in-out",
                      cursor: zoomLevel > 1 ? "grab" : "zoom-in",
                      borderRadius: "8px",
                    }}
                    onClick={handleImageClick}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default EventDetails;
